// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Box,
//   Typography,
//   Divider,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Stack,
//   TextField,
// } from "@mui/material";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";
// import SearchIcon from "@mui/icons-material/Search";
// import { useNavigate } from "react-router-dom";
// import StyledDataGrid from "../../components/StyledDataGrid";
// import SearchBar from "../../components/SearchBar";
// import PageHeader from "../../components/PageHeader";
// import { fetchSamplesPaged } from "utils/api";
// import { getSampleTypeFamily } from "utils/sampleIds";

// const TAMU_MAROON = "#500000";

// const SAMPLE_TYPES = [
//   "A - Blood Plasma",
//   "B - Blood Serum",
//   "C - Blood Protein",
//   "D - PAX DNA",
//   "E - PAX RNA",
//   "F - Urine",
//   "G - PBMC",
//   "H - Mitra",
//   "I - Saliva",
// ];

// const getTypeCode = (value) => {
//   if (!value) return "";
//   const rawCode = String(value).trim().split(/[\s-]+/)[0];
//   return getSampleTypeFamily(rawCode);
// };

// const labelToCode = (label) => getTypeCode(label);

// const formatCollectionDate = (rawValue) => {
//   if (!rawValue) return "N/A";

//   const date = new Date(rawValue);
//   if (Number.isNaN(date.getTime())) {
//     return String(rawValue);
//   }

//   const mm = String(date.getMonth() + 1).padStart(2, "0");
//   const dd = String(date.getDate()).padStart(2, "0");
//   const yyyy = date.getFullYear();
//   return `${mm}/${dd}/${yyyy}`;
// };

// const SampleData = () => {
//   const navigate = useNavigate();
//   const [selectedTypes, setSelectedTypes] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [totalRowCount, setTotalRowCount] = useState(0);
//   const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 });

//   const selectedTypeCodes = useMemo(
//     () => selectedTypes.map(labelToCode).filter(Boolean),
//     [selectedTypes]
//   );

//   useEffect(() => {
//     let cancelled = false;

//     (async () => {
//       try {
//         setLoading(true);
//         const response = await fetchSamplesPaged({
//           page: paginationModel.page,
//           size: paginationModel.pageSize,
//           unprocessedOnly: false,
//           sampleTypes: selectedTypeCodes,
//         });

//         if (cancelled) return;

//         const sampleRows = Array.isArray(response?.content) ? response.content : [];
//         setRows(
//           sampleRows.map((sample, index) => {
//             const barcode = sample?.sampleId || sample?.barcode || "N/A";
//             const typeCode = getTypeCode(sample?.sampleType);

//             return {
//               id: sample?.sampleId || `sample-${paginationModel.page}-${index}`,
//               barcode,
//               collectedAt: formatCollectionDate(sample?.encounterDateTime),
//               typeCode,
//             };
//           })
//         );
//         setTotalRowCount(response?.totalElements ?? 0);
//       } catch (error) {
//         console.error("Failed to load paged samples:", error);
//         if (!cancelled) {
//           setRows([]);
//           setTotalRowCount(0);
//         }
//       } finally {
//         if (!cancelled) setLoading(false);
//       }
//     })();

//     return () => {
//       cancelled = true;
//     };
//   }, [paginationModel.page, paginationModel.pageSize, selectedTypeCodes]);

//   const handleClearFilters = () => {
//     setSelectedTypes([]);
//     setSearchTerm("");
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const filteredRows = useMemo(() => {
//     const term = searchTerm.trim().toLowerCase();
//     if (!term) {
//       return rows;
//     }

//     return rows.filter((row) => {
//       const barcode = String(row.barcode || "").toLowerCase();
//       const collectedAt = String(row.collectedAt || "").toLowerCase();
//       return barcode.includes(term) || collectedAt.includes(term);
//     });
//   }, [rows, searchTerm]);

//   const columns = [
//     {
//       field: "barcode",
//       headerName: "Barcode ID",
//       flex: 1,
//       sortable: false,
//     },
//     {
//       field: "collectedAt",
//       headerName: "Sample Collection Date",
//       flex: 1,
//       sortable: false,
//     },
//   ];

//   return (
//     <Box
//       sx={{
//         p: 3,
//         height: "calc(100vh - 96px)",
//         display: "flex",
//         flexDirection: "column",
//         bgcolor: "#fff",
//         overflow: "hidden",
//       }}
//     >
//       <PageHeader title="Sample Data" />

//       <Box sx={{ display: "flex", alignItems: "stretch", gap: 2, flex: 1, minHeight: 0 }}>
//         <Box
//           sx={{
//             width: 250,
//             flexShrink: 0,
//             backgroundColor: "white",
//             border: "1px solid #000",
//             borderRadius: 0,
//             p: 2,
//             display: "flex",
//             flexDirection: "column",
//             overflow: "hidden",
//             "& .MuiFormControlLabel-root": { margin: 0 },
//             "& .MuiFormControlLabel-label": {
//               fontSize: "0.875rem",
//               lineHeight: 1.5,
//               color: "#000",
//             },
//           }}
//         >
//           {/* Search Box */}
//           <Box sx={{ mb: 1.5 }}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
//               <SearchIcon sx={{ color: TAMU_MAROON, fontSize: 20 }} />
//               <Typography sx={{ fontSize: "16px", fontWeight: 600, color: TAMU_MAROON }}>
//                 Search by ID or Date
//               </Typography>
//             </Box>
//             <Divider sx={{ mb: 1 }} />
//             <TextField
//               placeholder="Enter ID or Date..."
//               value={searchTerm}
//               onChange={(event) => setSearchTerm(event.target.value)}
//               size="small"
//               fullWidth
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   borderRadius: 0,
//                 }
//               }}
//             />
//           </Box>

//           <Box sx={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", pr: 1 }}>
//             <Box>
//               <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//                 <FilterAltIcon sx={{ color: TAMU_MAROON, fontSize: 20 }} />
//                 <Typography sx={{ fontSize: "16px", fontWeight: 600, color: TAMU_MAROON }}>
//                   Sample Type
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: 1 }} />
//               <Stack spacing={0.5}>
//                 {SAMPLE_TYPES.map((type) => (
//                   <FormControlLabel
//                     key={type}
//                     control={
//                       <Checkbox
//                         checked={selectedTypes.includes(type)}
//                         onChange={(event) =>
//                           setSelectedTypes((prev) =>
//                             event.target.checked
//                               ? [...prev, type]
//                               : prev.filter((currentType) => currentType !== type)
//                           )
//                         }
//                         sx={{ color: TAMU_MAROON }}
//                       />
//                     }
//                     label={type}
//                     sx={{
//                       m: 0,
//                       "& .MuiFormControlLabel-label": {
//                         fontSize: "0.875rem",
//                         color: "#000",
//                       },
//                     }}
//                   />
//                 ))}
//               </Stack>
//             </Box>
//           </Box>

//           <Box sx={{ pt: 2, mt: "auto", borderTop: "1px solid #eee" }}>
//             <Button
//               variant="outlined"
//               startIcon={<RefreshIcon sx={{ fontSize: 18 }} />}
//               onClick={handleClearFilters}
//               sx={{
//                 textTransform: "uppercase",
//                 backgroundColor: "#fff",
//                 color: TAMU_MAROON,
//                 borderColor: TAMU_MAROON,
//                 fontSize: "0.85rem",
//                 fontWeight: 600,
//                 borderRadius: 0,
//                 width: "100%",
//                 "&:hover": {
//                   backgroundColor: "rgba(80, 0, 0, 0.06)",
//                   borderColor: TAMU_MAROON,
//                 },
//               }}
//             >
//               CLEAR
//             </Button>
//           </Box>
//         </Box>

//         <Box
//           sx={{
//             flex: 1,
//             display: "flex",
//             flexDirection: "column",
//             minWidth: 0,
//             minHeight: 0,
//           }}
//         >
//           <Box
//             sx={{
//               flex: 1,
//               display: "flex",
//               flexDirection: "column",
//               minWidth: 0,
//               minHeight: 0,
//             }}
//           >
//             <StyledDataGrid
//               rows={filteredRows}
//               columns={columns}
//               loading={loading}
//               pagination
//               paginationMode="server"
//               rowCount={searchTerm.trim() ? filteredRows.length : totalRowCount}
//               paginationModel={paginationModel}
//               onPaginationModelChange={setPaginationModel}
//               pageSizeOptions={[10, 25, 50]}
//               disableSelectionOnClick
//               onRowClick={(params) => {
//                 const id = encodeURIComponent(params.row.barcode);
//                 navigate(`/admin/samples/${id}`, {
//                   state: { sample: params.row },
//                 });
//               }}
//               sx={{
//                 flex: 1,
//                 "& .MuiDataGrid-row": { cursor: "pointer" },
//               }}
//             />
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default SampleData;
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Divider,
  Checkbox,
  FormControlLabel,
  Button,
  Stack,
  TextField,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import StyledDataGrid from "../../components/StyledDataGrid";
import SearchBar from "../../components/SearchBar";
import PageHeader from "../../components/PageHeader";
import { fetchSamplesPaged } from "utils/api";
import { getSampleTypeFamily } from "utils/sampleIds";

const TAMU_MAROON = "#500000";

const SAMPLE_TYPES = [
  "A - Blood Plasma",
  "B - Blood Serum",
  "C - Blood Protein",
  "D - PAX DNA",
  "E - PAX RNA",
  "F - Urine",
  "G - PBMC",
  "H - Mitra",
  "I - Saliva",
];

const getTypeCode = (value) => {
  if (!value) return "";
  const rawCode = String(value)
    .trim()
    .split(/[\s-]+/)[0];
  return getSampleTypeFamily(rawCode);
};

const getTypeLabel = (rawType) => {
  if (!rawType) return "N/A";
  const code = String(rawType)
    .trim()
    .split(/[\s-]+/)[0]
    .toUpperCase();
  const match = SAMPLE_TYPES.find((label) =>
    label.toUpperCase().startsWith(`${code} `),
  );
  return match || rawType;
};

const labelToCode = (label) => getTypeCode(label);

const formatCollectionDate = (rawValue) => {
  if (!rawValue) return "N/A";

  const date = new Date(rawValue);
  if (Number.isNaN(date.getTime())) {
    return String(rawValue);
  }

  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

const SampleData = () => {
  const navigate = useNavigate();
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });

  const selectedTypeCodes = useMemo(
    () => selectedTypes.map(labelToCode).filter(Boolean),
    [selectedTypes],
  );

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setLoading(true);
        const response = await fetchSamplesPaged({
          page: paginationModel.page,
          size: paginationModel.pageSize,
          unprocessedOnly: false,
          sampleTypes: selectedTypeCodes,
        });

        if (cancelled) return;

        const sampleRows = Array.isArray(response?.content)
          ? response.content
          : [];

        setRows(
          sampleRows.map((sample, index) => {
            const barcode = sample?.sampleId || sample?.barcode || "N/A";
            const typeCode = getTypeCode(sample?.sampleType);

            return {
              id: sample?.sampleId || `sample-${paginationModel.page}-${index}`,
              barcode,
              collectedAt: formatCollectionDate(sample?.encounterDateTime),
              typeCode,
              type: getTypeLabel(sample?.sampleType),
              quality: sample?.sampleQuality || "N/A",
              totalAliquots: sample?.totalAliquots ?? "N/A",
              patientId: sample?.patientId || null,
            };
          }),
        );
        setTotalRowCount(response?.totalElements ?? 0);
      } catch (error) {
        console.error("Failed to load paged samples:", error);
        if (!cancelled) {
          setRows([]);
          setTotalRowCount(0);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [paginationModel.page, paginationModel.pageSize, selectedTypeCodes]);

  const handleClearFilters = () => {
    setSelectedTypes([]);
    setSearchTerm("");
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const filteredRows = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) {
      return rows;
    }

    return rows.filter((row) => {
      const barcode = String(row.barcode || "").toLowerCase();
      const collectedAt = String(row.collectedAt || "").toLowerCase();
      return barcode.includes(term) || collectedAt.includes(term);
    });
  }, [rows, searchTerm]);

  const columns = [
    {
      field: "barcode",
      headerName: "Barcode ID",
      flex: 1,
      sortable: false,
    },
    {
      field: "collectedAt",
      headerName: "Sample Collection Date",
      flex: 1,
      sortable: false,
    },
  ];

  return (
    <Box
      sx={{
        p: 3,
        height: "calc(100vh - 96px)",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#fff",
        overflow: "hidden",
      }}
    >
      <PageHeader title="Sample Data" />

      <Box
        sx={{
          display: "flex",
          alignItems: "stretch",
          gap: 2,
          flex: 1,
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            width: 250,
            flexShrink: 0,
            backgroundColor: "white",
            border: "1px solid #000",
            borderRadius: 0,
            p: 2,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            "& .MuiFormControlLabel-root": { margin: 0 },
            "& .MuiFormControlLabel-label": {
              fontSize: "0.875rem",
              lineHeight: 1.5,
              color: "#000",
            },
          }}
        >
          <Box sx={{ mb: 1.5 }}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
            >
              <SearchIcon sx={{ color: TAMU_MAROON, fontSize: 20 }} />
              <Typography
                sx={{ fontSize: "16px", fontWeight: 600, color: TAMU_MAROON }}
              >
                Search by ID or Date
              </Typography>
            </Box>
            <Divider sx={{ mb: 1 }} />
            <TextField
              placeholder="Enter ID or Date..."
              value={searchTerm}
              onChange={(event) => setSearchTerm(event.target.value)}
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 0,
                },
              }}
            />
          </Box>

          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              pr: 1,
            }}
          >
            <Box>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
              >
                <FilterAltIcon sx={{ color: TAMU_MAROON, fontSize: 20 }} />
                <Typography
                  sx={{ fontSize: "16px", fontWeight: 600, color: TAMU_MAROON }}
                >
                  Sample Type
                </Typography>
              </Box>
              <Divider sx={{ mb: 1 }} />
              <Stack spacing={0.5}>
                {SAMPLE_TYPES.map((type) => (
                  <FormControlLabel
                    key={type}
                    control={
                      <Checkbox
                        checked={selectedTypes.includes(type)}
                        onChange={(event) =>
                          setSelectedTypes((prev) =>
                            event.target.checked
                              ? [...prev, type]
                              : prev.filter(
                                  (currentType) => currentType !== type,
                                ),
                          )
                        }
                        sx={{ color: TAMU_MAROON }}
                      />
                    }
                    label={type}
                    sx={{
                      m: 0,
                      "& .MuiFormControlLabel-label": {
                        fontSize: "0.875rem",
                        color: "#000",
                      },
                    }}
                  />
                ))}
              </Stack>
            </Box>
          </Box>

          <Box sx={{ pt: 2, mt: "auto", borderTop: "1px solid #eee" }}>
            <Button
              variant="outlined"
              startIcon={<RefreshIcon sx={{ fontSize: 18 }} />}
              onClick={handleClearFilters}
              sx={{
                textTransform: "uppercase",
                backgroundColor: "#fff",
                color: TAMU_MAROON,
                borderColor: TAMU_MAROON,
                fontSize: "0.85rem",
                fontWeight: 600,
                borderRadius: 0,
                width: "100%",
                "&:hover": {
                  backgroundColor: "rgba(80, 0, 0, 0.06)",
                  borderColor: TAMU_MAROON,
                },
              }}
            >
              CLEAR
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            minHeight: 0,
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              minWidth: 0,
              minHeight: 0,
            }}
          >
            <StyledDataGrid
              rows={filteredRows}
              columns={columns}
              loading={loading}
              pagination
              paginationMode="server"
              rowCount={searchTerm.trim() ? filteredRows.length : totalRowCount}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              pageSizeOptions={[10, 25, 50]}
              disableSelectionOnClick
              onRowClick={(params) => {
                const id = encodeURIComponent(params.row.barcode);
                navigate(`/admin/samples/${id}`, {
                  state: { sample: params.row },
                });
              }}
              sx={{
                flex: 1,
                "& .MuiDataGrid-row": { cursor: "pointer" },
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SampleData;
